import { paletteTheme } from "@configs/theme/custom/palette";

export const selectTheme = {
  singleItemHeightLG: 48,
  optionHeight: 36,
  optionSelectedColor: paletteTheme.colorPrimary,
  optionActiveBg: paletteTheme.colorFillSecondary,
  colorText: paletteTheme.colorPrimary,
};
